import React from 'react';
import { useReels } from '../../../../../contexts/reels';

export const ImageThumbnail: React.FC<{
  url: string;
  isAdded?: boolean;
  onAddOrRemoveTimeline: (duration: number) => void;
}> = ({ url, isAdded, onAddOrRemoveTimeline }) => {
  const {
    global_settings: {
      transition: { default_image_duration_secs }
    }
  } = useReels();

  return (
    <>
      <img
        src={url}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />

      <div
        className={'timeline-item-overlay'}
        title={isAdded ? 'Remove from timeline' : 'Add to timeline'}
        onClick={() => onAddOrRemoveTimeline(default_image_duration_secs)}
      />
    </>
  );
};
